import React,{useState} from "react";

import {Link } from "react-router-dom";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const MyDatePicker = ({onchange,placeholder,name,value,baseUrl ,title,disable})=>{ 
     const date = value?.slice(0, 10);
  const [valueInput , setValueInput] = useState({val:date});
  const [selectedDate, setSelectedDate] = useState(null);
 
 // Get the current date
 const today = new Date();
 const year = today.getFullYear();
 const month = String(today.getMonth() + 1).padStart(2, '0');
 const day = String(today.getDate()).padStart(2, '0');
 const minDate = `${year}-${month}-${day}`;

     return(<>
      <div  className="popup-backgrop">
      <div  className="popup-card">
        <div  className="blank"> </div>
    <div  className="popup-outer">
 <div  className="popup-inner"> 

    <div  className="login-signup-left-signup"><h1 style={{"textAlign":"center"}}>Update {title} </h1>
    <div  className="popup-input-card">
        <DatePicker
        selected={selectedDate}
        onChange={(date) => setSelectedDate(date)}
        dateFormat="MM/dd/yyyy"
        isClearable
        placeholderText="Select a date"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        // minDate={new Date()} // Disable past dates
//   maxDate={new Date().setMonth(new Date().getMonth() + 1)}
maxDate={new Date()}

//   highlightDates={[
//     new Date(), // Highlight today
//     new Date().setDate(new Date().getDate() + 1) // Highlight tomorrow
//   ]}
//   inline 

      />
    
    </div>
    <div  className="popup-button-card">
      <button  className="green-button" type="submit" id="signupBtn">{value?"Update":"Add"}</button>
  
  <Link to={baseUrl} className="black-button">
close
 </Link>
  
  </div>
   
  </div>
   </div>
   
   </div>
	    
	</div></div>                              
     </>)  
   }
   export default MyDatePicker;